import { createApp } from 'vue';
import App from './App.vue';
import router from './router';

// Configure Vue feature flags
window.__VUE_PROD_HYDRATION_MISMATCH_DETAILS__ = false;
import './assets/bootstrap-flatly.css';
import './assets/theme.css';
import 'bootstrap-vue/dist/bootstrap-vue.min.js';
import { library } from "@fortawesome/fontawesome-svg-core";
import { FontAwesomeIcon } from "@fortawesome/vue-fontawesome";
import { fas } from "@fortawesome/free-solid-svg-icons";
import { createHead } from '@unhead/vue';
import axiosPlugin from './plugins/axiosPlugin';
import { eventBus } from './eventBus';

library.add(fas);

const app = createApp(App);
app.config.globalProperties.$eventBus = eventBus;

const head = createHead()
app.component("font-awesome-icon", FontAwesomeIcon);
app.use(router);
app.use(head);
app.use(axiosPlugin);
app.mount('#app');
